// extracted by mini-css-extract-plugin
module.exports = {"loadingPage":"LoadingPageMobile_loadingPage_30xwY","loadingBoxMobile":"LoadingPageMobile_loadingBoxMobile_Oe2zk","footerLogo":"LoadingPageMobile_footerLogo_6x5qI"};